export default __webpack_public_path__ + "static/media/CMS_Transactions.0399600f.svg";